import React from 'react';
import {t, endpoints, types} from 'shared/core';
import {InteractiveTable, DropdownFilter} from 'components';
import {EmployeeTrainingStatus} from 'stores/training';
import {observer} from 'mobx-react';
import EmployeeProfileContainer from '../../EmployeeProfileContainer';

const COLUMNS = [
  {
    header: 'employees.profile.training.Program Name',
    width: 6,
    attribute: 'program.name'
  },
  {
    header: 'employees.profile.training.Due Date',
    width: 3,
    attribute: 'dueDateView'
  },
  {
    header: 'employees.profile.training.Completed Date',
    width: 3,
    attribute: 'completedAtView'
  }
];

const LOCALIZATION = {
  emptyState: 'employees.profile.training.No training to display'
};

function statusFilters() {
  return [
    {
      id: 'incomplete',
      display: t('employees.profile.training.Incomplete Training')
    },
    {
      id: 'complete',
      display: t('employees.profile.training.Completed Training')
    }
  ];
}

const TrainingContainer = observer(({uiState}) => {
  const {employee} = uiState;

  return (
    <EmployeeProfileContainer uiState={uiState}>
      <InteractiveTable
        title={t('employees.profile.training.Training')}
        columns={COLUMNS}
        showLinks={false}
        saveStateToUrl={true}
        showPath={model => `/training/programs/${model.id}`}
        proxy={{
          type: 'async',
          endpoint: endpoints.TRAINING.EMPLOYEE_TRAINING_STATUSES.with(employee.id),
          modelType: types.TRAINING.EMPLOYEE_TRAINING_STATUS,
          model: EmployeeTrainingStatus
        }}
        localization={LOCALIZATION}
      >
        <DropdownFilter options={statusFilters()} attr='status'/>
      </InteractiveTable>
    </EmployeeProfileContainer>
  );
});

export default TrainingContainer;
